<template>
    <v-dialog
        v-model="dialog"
        max-width="500"
        @keydown.esc="cancel"
        :persistent="processing"
    >
        <v-card>
            <v-card-title class="headline">
                {{ $t('actions.bill.archive.title') }}
                <v-spacer></v-spacer>
                <v-btn icon @click="dialog = false">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text>
                <p>{{ $t('actions.bill.archive.p1') }}</p>
                <p>{{ $t('actions.bill.archive.p2') }}</p>
            </v-card-text>
            <v-card-actions>
                <v-btn class="col" text @click="close" :disabled="processing">
                    {{ $t('actions.close') }}
                </v-btn>
                <v-divider vertical=""></v-divider>
                <v-btn
                    class="col"
                    color="red darken-1"
                    text
                    @click="perform"
                    :loading="processing"
                >
                    {{ $t('actions.bill.archive.perform') }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    data() {
        return {
            dialog: false,
            model: undefined,
            processing: false,
        }
    },

    methods: {
        open(model) {
            this.dialog = true
            this.model = model
        },

        close() {
            this.model = undefined
            this.dialog = false
        },

        async perform() {
            this.processing = true
            let res = await this.model.archive()
            this.processing = false
            this.dialog = false

            if (!res) return

            this.$emit('modelChanged')
            this.$bus.$emit(
                'notify',
                'success',
                this.$t('actions.bill.archive.success'),
            )
        },
    },
}
</script>

<style></style>
